import { render, staticRenderFns } from "./UsersWeek.vue?vue&type=template&id=53651090&"
import script from "./UsersWeek.vue?vue&type=script&lang=js&"
export * from "./UsersWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports